import { SettingsAuditTagsSection } from "@/components/settings";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/settings/audit-tags")({
  component: SettingsAuditTagsSection,
});
